<script setup lang="ts">
import Dragger from "./Dragger.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import EraserSizeBtn from "./options/EraserSizeBtn.vue";
import DisableToolBtn from "./options/DisableToolBtn.vue";
import Settings from "@/stores/Settings";
</script>

<template>
  <ToolOptionsDropdown :owners="[DraggerType.Eraser]">
    <template #tool>
      <Dragger
        :config="{ name: DraggerType.Eraser }"
        phosphor-icon="eraser"
        :tooltip-title="$t('canvas:tools.eraser.tooltip.title')"
        :tooltip-text="$t('canvas:tools.eraser.tooltip.text')"
        @click="DraggerMenuState.setActiveDragger({ name: DraggerType.Eraser })"
      />
    </template>
    <div class="rounded p-1" style="background-color: var(--canvas-bg)">
      <!-- Sans stylet, un doigt sur le dessin gomme au lieu de naviguer :
           la croix rend la main a la navigation. -->
      <template v-if="!Settings.onlyStylusOn">
        <div class="btn-group-vertical w-100">
          <DisableToolBtn />
        </div>
        <div class="canvas-divider-horizontal my-1"></div>
      </template>
      <EraserSizeBtn />
    </div>
  </ToolOptionsDropdown>
</template>
